export const AD_TYPES = {
    newDesktopBoxStandard: "newDesktopBoxStandard",
    newDesktopBoxFlex: "newDesktopBoxFlex",
    newDesktopImmersive: "newDesktopImmersive",
    newTabletImmersive: "newTabletImmersive",
    newMobileImmersive: "newMobileImmersive",
    newMobileBox: "newMobileBox",
    brandMetrics: "brandMetrics",
    programmaticMobile: "programmaticMobile",
};

export const VALID_AD_TYPES = new Set(Object.values(AD_TYPES));

export function getAdOptions(
    type: string,
    pageId: string,
    positionIncrement?: number | null
) {
    switch (type) {
        case "newMobileBoxForCoJp": {
            return {
                dimensions: {
                    mobile: [
                        [320, 50],
                        [300, 250],
                        [3, 3],
                        [5, 16],
                        [5, 5],
                        [5, 19],
                    ],
                },
                targeting: {
                    position: `box${positionIncrement}`,
                    page: pageId,
                },
            };
        }

        case "newSponsored": {
            return {
                dimensions: {
                    small_desktop: [[190, 31]],
                    large_desktop: [[190, 31]],
                    tablet: [[190, 31]],
                    mobile: [[190, 31]],
                },
                targeting: {
                    position: `greensponsoredby${positionIncrement}`,
                    page: pageId,
                },
            };
        }

        case "videoSponsoredLogo": {
            return {
                adCode: "business/equality",
                strategy: "always",
                pageId,
                position: "sponsoredbynv",
                dimensions: {
                    all: [[88, 31]],
                },
                type: "sponsoredbynv",
                targeting: {
                    position: "sponsoredbynv",
                    page: pageId,
                },
                containerId: `sponsoredbynv-${pageId}-${positionIncrement}`,
            };
        }

        default: {
            return {
                dimensions: {
                    all: [[5, 16]],
                    large_desktop: [[970, 250]],
                    small_desktop: [[970, 250]],
                    mobile: [
                        [320, 50],
                        [300, 50],
                    ],
                },
            };
        }
    }
}
